import {
  IonText,
  IonRow,
  IonCol,
  IonCard,
  IonItem,
  IonLabel,
  IonButton,
  IonDatetime,
  useIonToast,
} from "@ionic/react";
import { useState, useEffect } from "react";
import { UserFile } from "../../../@types/userFiles";
import { FileHolder } from "../../../@types/fileHolder";
import { useDispatch } from "react-redux";
import { uploadDocument } from "../../../store/userShow/actions/uploadFile";

interface ComponentProps {
  document: UserFile[];
  userId: string;
  ownerId: string;
}

const thisYear = new Date().getFullYear();
const limitYear = thisYear + 3;

export const UploadDocument: React.FC<ComponentProps> = ({ document, userId, ownerId }) => {
  const [selectedDate, setSelectedDate] = useState<string>();
  const [fileHolder, setFileHolder] = useState<FileHolder[]>([]);
  const [presentToast, hideToast] = useIonToast();
  const dispatch = useDispatch();

  const dateParsedToPost = selectedDate?.replace(/T.*/, "").split("-").reverse().join("/");

  const onSelectFile = (e: any) => {
    const newFileHolder = [
      {
        file: e.target.files[0],
        id: document[0].id!,
        userId: userId,
        ownerId: ownerId,
        expirationDate: ""
      },
    ];
    setFileHolder(newFileHolder);
  };

  useEffect(() => {
    if(fileHolder.length > 0) {
      fileHolder[0].expirationDate = dateParsedToPost
    }
  }, [selectedDate])

  const handleSendNotification = async (fileHolder: FileHolder[]) => {
    if (fileHolder.length === 0) {
      presentToast({
        message: " Debe Subir un Archivo antes de guardar",
        color: "danger",
        duration: 3000,
      });
    } else {
      try {
        await hideToast();
        presentToast({
          message: `Cargando Archivo...`,
          color: "primary",
        });
        let responseMessage = "";
        if (fileHolder.length > 0) {
          const { payload: notificationCreated }: any =
            (await dispatch(uploadDocument(fileHolder))) || {};
          if (!notificationCreated) {
            throw new Error("No se pudo cargar el archivo");
          } else {
            responseMessage = notificationCreated;
          }
        }
        await hideToast();
        presentToast({
          message: responseMessage,
          color: "success",
          duration: 8000,
        });
      } catch (error) {
        await hideToast();
        presentToast({
          message: "Ocurrió un problema al enviar el archivo",
          color: "danger",
          duration: 8000,
        });
      }
    }
  };

  return (
    <>
      <IonCard className="ion-margin-start">
        <IonItem style={{ justifyContent: "center", display: "flex" }}>
          <IonRow style={{ width: "100%", padding: 20 }}>
            <IonCol style={{ justifyContent: "center", display: "flex" }}>
              <IonText color="primary">{document[0].name}</IonText>
            </IonCol>
          </IonRow>
        </IonItem>
        <IonItem>
          <IonRow style={{ width: "100%", padding: 20 }}>
            <IonCol style={{ textAlign: "center" }}>
              <IonButton color="primary" style={{ fontWeight: 300 }} size={"default"}>
                <label htmlFor="docButton" style={{ cursor: "pointer" }}>
                  <IonLabel>
                    <p style={{ fontWeight: 500 }}>SUBIR DOCUMENTO</p>
                  </IonLabel>
                </label>
              </IonButton>
              <input
                type="file"
                id="docButton"
                name={`${document[0].name}`}
                style={{ display: "none" }}
                onChange={(event) => onSelectFile(event)}
                accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                required
              />
              <IonLabel>
                {fileHolder.length > 0 ? <p>{fileHolder[0].file.name}</p> : <p>Nombre Archivo</p>}
              </IonLabel>
            </IonCol>
          </IonRow>
        </IonItem>
        {document[0].datesRequire === true && (
          <IonItem>
            <IonRow style={{ width: "100%", padding: 20 }}>
              <IonCol style={{ textAlign: "center" }}>
                <IonLabel>
                  <IonDatetime
                    displayFormat="DD MMM, YYYY"
                    placeholder="Seleccione Fecha"
                    monthShortNames="Enero, Febrero, Marzo, Abril, Mayo, Junio, Julio, Agosto, Sept, Oct, Nov, Dic"
                    min={`${thisYear}`}
                    max={`${limitYear}`}
                    doneText="Aceptar"
                    cancelText="Cancelar"
                    value={selectedDate}
                    onIonChange={(e) => setSelectedDate(e.detail.value!)}
                  ></IonDatetime>
                </IonLabel>
                <IonLabel>
                  <p>Fecha de vencimiento</p>
                </IonLabel>
              </IonCol>
            </IonRow>
          </IonItem>
        )}
        <IonRow style={{ textAlign: "center", padding: 20 }}>
          <IonCol>
            <IonButton onClick={() => handleSendNotification(fileHolder)}>Guardar</IonButton>
          </IonCol>
        </IonRow>
      </IonCard>
    </>
  );
};
